<nav class="navbar text-light">
  <div class="container-fluid">
    <h3>Puzzle: {{ puzzleId }}</h3>
    <div>
      <a href="#" class="text-light text-decoration-none" (click)="logout()">{{ user.displayName }} <i class="bi bi-box-arrow-right"></i></a>
    </div>
  </div>
</nav>
